import { useFlags } from 'launchdarkly-react-client-sdk';

import Dashboard from 'components/Dashboard/Dashboard';
import { useFeatureFlagRedirect } from 'hooks/useFeatureFlagRedirect';

export interface DashboardRouteProps {
  location?: unknown;
  navigate?: unknown;
}

/**
 * Route wrapper for the legacy dashboard.
 *
 * When `enableDashboardRedesign` is on, redirect to the liscio-frontend
 * dashboard. When the flag is off, render the legacy Dashboard unchanged.
 */
export default function DashboardRoute({
  location,
  navigate,
}: DashboardRouteProps) {
  const { enableDashboardRedesign } = useFlags();

  const { uiReady } = useFeatureFlagRedirect({
    redirectPath: '/dashboard/home',
    isEnabled: enableDashboardRedesign,
  });

  if (!uiReady) {
    return null;
  }

  return <Dashboard location={location} navigate={navigate} />;
}
